module.exports = __webpack_public_path__ + "static/img/left.a645275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/left.png
// module id = F0Yv
// module chunks = 1